/* eslint-disable */
/**
 * This file was generated by Itecho.TSGen tool
 * Version and info generated in .version
 * Any changes to this file will be lost if regenerated 
 */

import { webRequest, fileRequest } from "../request";
import type DashboardFarmDisplay from "../interfaces/dashboardFarmDisplay";
import type DashboardLandDisplay from "../interfaces/dashboardLandDisplay";
import type FarmDisplay from "../interfaces/farmDisplay";
import type FarmLandGeojson from "../interfaces/farmLandGeojson";
import type IdRequest from "../interfaces/idRequest";
import type LandBoundaryCoordinates from "../interfaces/landBoundaryCoordinates";
import type LandWeightRequest from "../interfaces/landWeightRequest";
import type LocationDataGrouped from "../interfaces/locationDataGrouped";
import type LocationSeasonRequest from "../interfaces/locationSeasonRequest";
import type PaginationRequestCustomFarm from "../interfaces/paginationRequestCustomFarm";
import type PaginationRequestIdSearch from "../interfaces/paginationRequestIdSearch";
import type PaginationRequestSearch from "../interfaces/paginationRequestSearch";
import type PaginationResponse from "../interfaces/paginationResponse";
import type WeightsPaged from "../interfaces/weightsPaged";

export default {
    paged: (request: PaginationRequestSearch) => webRequest<PaginationResponse<FarmDisplay>>('/api/farm/paged', {
        method: 'post',
        body: request
    }),
    update: (farm: FarmDisplay) => webRequest<unknown>('/api/farm/update', {
        method: 'post',
        body: farm
    }),
    landsPaged: (request: PaginationRequestCustomFarm) => webRequest<PaginationResponse<DashboardLandDisplay>>('/api/farm/landspaged', {
        method: 'post',
        body: request
    }),
    processFarm: (request: IdRequest) => webRequest<unknown>('/api/farm/processfarm', {
        method: 'post',
        body: request
    }),
    sync: (request: IdRequest) => webRequest<unknown>('/api/farm/sync', {
        method: 'post',
        body: request
    }),
    removePoints: (request: IdRequest) => webRequest<unknown>('/api/farm/removepoints', {
        method: 'post',
        body: request
    }),
    createTiff: (request: IdRequest) => webRequest<unknown>('/api/farm/createtiff', {
        method: 'post',
        body: request
    }),
    weightsPaged: (request: PaginationRequestIdSearch) => webRequest<PaginationResponse<WeightsPaged>>('/api/farm/weightspaged', {
        method: 'post',
        body: request
    }),
    deleteWeight: (request: IdRequest) => webRequest<unknown>('/api/farm/deleteweight', {
        method: 'post',
        body: request
    }),
    locationData: (request: LocationSeasonRequest) => webRequest<LocationDataGrouped[]>('/api/farm/locationdata', {
        method: 'post',
        body: request
    }),
    addLandWeight: (request: LandWeightRequest) => webRequest<unknown>('/api/farm/addlandweight', {
        method: 'post',
        body: request
    }),
    downloadLocationDataGroupedDay: (request: LocationSeasonRequest) => fileRequest('/api/farm/downloadlocationdatagroupedday', {
        queryParams: {
            ...request
        }
    }),
    downloadLocationData: (request: LocationSeasonRequest) => fileRequest('/api/farm/downloadlocationdata', {
        queryParams: {
            ...request
        }
    }),
    available: (request: PaginationRequestSearch) => webRequest<PaginationResponse<DashboardFarmDisplay>>('/api/farm/available', {
        method: 'post',
        body: request
    }),
    landBoundary: (id: number) => webRequest<LandBoundaryCoordinates[]>('/api/farm/landboundary', {
        queryParams: {
            id
        }
    }),
    geoJson: (id: number) => webRequest<FarmLandGeojson>('/api/farm/geojson', {
        queryParams: {
            id
        }
    })
}